import { render, staticRenderFns } from "./videoLiveing.vue?vue&type=template&id=8332a1d8&scoped=true&"
import script from "./videoLiveing.vue?vue&type=script&lang=js&"
export * from "./videoLiveing.vue?vue&type=script&lang=js&"
import style0 from "./videoLiveing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./videoLiveing.vue?vue&type=style&index=1&id=8332a1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8332a1d8",
  null
  
)

export default component.exports